import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setWaitingForAction } from "../../store/actions/play-actions";


class BuyOrSubscribePopupSiteEvent extends Component
{

    generateEvent() {
        let buyOrSubscribePopupEvent = new CustomEvent('buy_or_subscribe_popup_open', {detail: {...this.props.bookInfo}});
        document.dispatchEvent(buyOrSubscribePopupEvent);
        this.props.setWaitingForAction(true);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.loginPopupVisible && this.props.loginPopupVisible && this.props.isLogged) {
            this.generateEvent();
        }
    }

    render() {
        return null;
    }
}
const mapStateToProps = (state) => {
    return {

        loginPopupVisible: state.loginPopup.isVisible,
        bookInfo: state.book.bookInfo,
        isLogged: state.book.isLogged,
    };
};

export default connect(mapStateToProps,{
    setWaitingForAction,
})(BuyOrSubscribePopupSiteEvent)


// WEBPACK FOOTER //
// ./src/containers/event-dispatcher/BuyOrSubscribePopupSiteEvent.jsx